let isScrollLocked = false
let scrollPosition = 0
let activeModals = 0

export function lockScroll(): void {
  if (typeof window === 'undefined') return

  activeModals++

  if (isScrollLocked) return

  scrollPosition = window.pageYOffset || document.documentElement.scrollTop

  const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth

  document.body.style.overflow = 'hidden'
  document.body.style.position = 'fixed'
  document.body.style.top = `-${scrollPosition}px`
  document.body.style.width = '100%'

  if (scrollBarWidth > 0) {
    document.body.style.paddingRight = `${scrollBarWidth}px`
  }

  isScrollLocked = true
}

export function unlockScroll(): void {
  if (typeof window === 'undefined') return

  activeModals = Math.max(0, activeModals - 1)

  if (activeModals > 0) return

  if (!isScrollLocked) return

  document.body.style.overflow = ''
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.width = ''
  document.body.style.paddingRight = ''

  window.scrollTo(0, scrollPosition)

  isScrollLocked = false
}
